import React, { FunctionComponent } from 'react'

import { IProps } from './IProps'
import { GridMainHeading as Heading } from './style'

export const GridMainHeading: FunctionComponent<IProps> = (props) => {
    return (
        <Heading colorGuide={props.colorGuide} style={props.style}>
            {props.children}
        </Heading>
    )
}
